
        <header
        class="br_header header-default header-transparent light-logo--version haeder-fixed-width headroom--sticky header-mega-menu clearfix">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="header__wrapper mr--0">
                        <!-- Header Left -->
                        <div class="header-left flex-20">
                            <div class="logo">
                                <a href="/">
                                    <img src="assets/img/logo/brook-white.png" alt="Escuela Akashica">
                                </a>
                            </div>
                        </div>
                        <!-- Mainmenu Wrap -->
                        <div class="header-flex-right flex-80">
                            <div class="mainmenu-wrapper have-not-flex d-none d-lg-block">
                                <nav class="page_nav" id="menu">
                                    <ul class="mainmenu">

                                        <li class="lavel-1  slide--megamenu"><a
                                                [routerLink]="['/inicio']"><span>Bienvenido</span></a></li>
                                        <li class="lavel-1 "><a routerLink="/nosotros"><span>Nosotros</span></a>
                                        </li>
                                        <li class="lavel-1 slide--megamenu"><a
                                                href="neuroakashico"><span>NeuroAkashico<sup>®</sup></span></a>
                                        <li class="lavel-1 slide--megamenu"><a href="tienda"><span>Tienda</span></a>
                                        <li class="lavel-1 with--drop slide-dropdown"><a
                                                href="#"><span>Más</span></a>

                                            <!-- Start Dropdown Menu -->
                                            <ul class="dropdown__menu">
                                                <li><a href="directorio"><span>Directorio</span></a></li>
                                                <li><a href="calendario"><span>Calendario</span></a></li>
                                                <li><a href="radio-galeria"><span>Radio & Galería</span></a></li>
                                                <li><a href="ninos"><span>Niños</span></a></li>
                                                <li><a href="congreso-virtual"><span>Congreso Virtual</span></a>
                                                </li>
                                                <li><a href="beneficios"><span>Beneficios</span></a></li>
                                                <li><a href="contacto"><span>Contacto</span></a></li>



                                            </ul>
                                            <!-- End Dropdown Menu -->
                                        </li>

                                        <li class="lavel-1 slide--megamenu"><a
                                                href="https://escuelaakashica.com/dir/login/index.php"
                                                target="_blank"><span>Login</span></a></li>
                                        <li class="lavel-1 slide--megamenu"><a
                                                href="https://escuelaakashica.classonlive.com/"
                                                target="_blank"><span>Streaming</span></a></li>








                                    </ul>
                                </nav>
                            </div>
                            <!-- Header Right -->
                            <div class="header-right have-not-flex d-sm-flex pl--35 pr_md--40 pr_sm--40">
                                <!-- Start Social Icon -->
                                <ul
                                    class="social-icon icon-size-medium text-center tooltip-layout d-none d-sm-flex">
                                    <li class="facebook"><a
                                            href="https://www.facebook.com/AnaSilviaCoachNeuroAkashico/"
                                            target="_blank" class="link hint--bounce hint--top hint--white"
                                            aria-label="Facebook"><i class="fab fa-facebook"></i></a></li>
                                    <li class="twitter"><a href="https://twitter.com/AnaSilviaNeuroA"
                                            target="_blank" class="link hint--bounce hint--top hint--white"
                                            aria-label="Twitter"><i class="fab fa-twitter"></i></a></li>
                                    <li class="instagram"><a
                                            href="https://www.instagram.com/ana_silvia_neuro_akashico/"
                                            target="_blank" class="link hint--bounce hint--top hint--white"
                                            aria-label="Instagram"><i class="fab fa-instagram"></i></a></li>
                                </ul>
                                <!-- End Social Icon -->
                                <!-- Start Hamberger -->
                                <div
                                    class="manu-hamber popup-mobile-click d-lg-none light-version d-block d-xl-none pl_md--20 pl_sm--20">
                                    <div>
                                        <i></i>
                                    </div>
                                </div>
                                <!-- End Hamberger -->
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </header>